import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import Login from '../components/Login';

const LoginPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useLanguage();

  // Get the location the user was trying to access.
  const from = location.state?.from?.pathname || '/';

  const redirectMessage = from !== '/'
    ? t('auth.login.redirectMessage')
    : null;

  const handleLoginSuccess = (loggedInUser, loginResult = {}) => {
    // 1. If they were trying to access a specific page before logging in, send them there.
    if (from && from !== '/') {
      navigate(from, { replace: true });
      return;
    }

    // 2. Route based on role
    const userRole = loggedInUser?.role;
    
    if (userRole === 'admin') {
      navigate('/admin/dashboard', { replace: true });
    } else if (['consultant', 'vastu_consultant'].includes(userRole) || loginResult?.hasVastuConsultantAccess) {
      // Vastu Consultants ONLY go to their desk, not the admin panel
      navigate('/vastu-consultant-desk', { replace: true });
    } else {
      // Standard users go to their dashboard
      navigate('/dashboard/bookings', { replace: true });
    }
  };

  return (
    <Login
      onLoginSuccess={handleLoginSuccess}
      redirectMessage={redirectMessage}
    />
  );
};

export default LoginPage;